import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-components";
import { Dismiss24Filled } from "@fluentui/react-icons";
import React from "react";
import sidebarLogo from '../../../assets/sidebar-logo.png';
import { ScenarioDetails } from "../../scenario-details/scenario-details.component";
import { ScenarioResultModel } from "../../../swagger-clients/excel-runner-api-clients.service";
import { getScenariosClient } from "../../../services/excel-runner.service";
import { HubConnection } from "@microsoft/signalr";
import { processServerError } from "../../../utils/helpers/error.helper";
import { ApplicationTryNowButton } from "../../../components/application-try-now-button/application-try-now-button.component";
import { WizardApplication } from "../../../components/create-experiment-wizard/create-experiment-wizard.modal";

type ScenarioDetailsModalProps = {
    scenarioId: number;
    isOpened?: boolean;
    hubConnection: HubConnection;
    onClose?: () => void;
}

export const ScenarioDetailsModal: React.FC<ScenarioDetailsModalProps> = (props) => {

    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        setOpen(!!props.isOpened);
    }, [props.isOpened]);




    const onClose = () => {
        setOpen(false);

        if (props.onClose) {
            props.onClose();
        }
    }


    return <Dialog open={open} onOpenChange={(event, data) => {
        setOpen(data.open);
        if (!data.open) {
            onClose();
        }

    }}>
        <DialogSurface style={{ minWidth: "95vw" }}>

            <DialogBody style={{ height: "90vh" }}>
                <DialogTitle action={<Button appearance="transparent" onClick={onClose} icon={<Dismiss24Filled />} />}
                    style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    {isLoading && <span>-</span>}
                    {!isLoading && <span>Design of Experiment (DoE) Example</span>}
                    <span style={{
                        color: "grey",
                        fontSize: "1rem",
                        fontWeight: "400",
                        fontStyle: "italic",
                        display: "flex",
                        alignItems: "center"
                    }}>
                        powered by  <img src={sidebarLogo} className="disable-visual-search" style={{ width: "auto", height: "40px" }} alt='Simulate 365 logo' /> </span>
                </DialogTitle>
                <DialogContent>
                    <ScenarioDetails scenarioId={props.scenarioId} isExample hubConnection={props.hubConnection} />

                </DialogContent>
                <DialogActions>
                    <ApplicationTryNowButton hubConnection={props.hubConnection} application={WizardApplication.DoE} />
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>
}
